import React, { useState, useEffect } from "react";
import { CheckCircle, Users, Target, Award, Send, User, Mail, Phone, ExternalLink, BookOpen, Loader2, Sparkles } from "lucide-react";
import axios from "axios";
import axiosInstance from "@/axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

// Mock Loading Component
const Loading = () => (
  <div className="flex items-center justify-center space-x-2">
    <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
    <span className="text-gray-600">Loading...</span>
  </div>
);

const InterestedForm = () => {
  const [data, setData] = useState(null);
  const { courses, isFetching } = useSelector(state => state?.course || []);
  console.log("Courses:", courses);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    course: '',
    phone: '',
    linkedin: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Mock data for demonstration
 useEffect(() => {  
    async function fetchBannerData() {
      try {  
      const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/Instructor`);  
        console.log("llllllllllllllll API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("444444 44API Response:", events); 
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("kkkkkError fetching banner data:", error);
      } 
    }
    fetchBannerData();
 },[]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axiosInstance.post("/request/instructor", formData);

      setSubmitted(true);
      toast.success("Message sent successfully!");
      setFormData({ name: "", email: "", course: "", phone: "", linkedin: "" });
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    }
    // setTimeout(() => {
    //   setIsSubmitting(false);
    //   setSubmitted(true);
    // }, 2000);
  };

  if (!data) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
        <div className="bg-white rounded-3xl shadow-2xl p-12">
          <Loading />
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl p-12 text-center max-w-md w-full">
          <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
            
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Thank You!</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Your application has been submitted successfully. A yslearn representative will reach out to you within 24-48 hours.
          </p>
          <div className="p-4 bg-green-50 rounded-xl">
            <p className="text-green-700 text-sm font-medium">
              Application ID: INS{Math.floor(Math.random() * 10000)}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden mt-20">
      {/* Animated Background Elements */}
      <div className="!absolute inset-0">
        <div className="!absolute top-20 left-20 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="!absolute top-40 right-20 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
        <div className="!absolute bottom-20 left-1/3 w-80 h-80 bg-cyan-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
      </div>
    
      {/* Background Pattern */}
      <div className="!absolute inset-0 opacity-20">
        <div className="!absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%236366f1' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-8 lg:py-16">

        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white/80 backdrop-blur-sm border border-blue-200 text-blue-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
            <Sparkles className="w-5 h-5 mr-2" />
            Instructor Opportunities
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
              {data.title}
            </span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Transform lives through education and build your legacy as a world-class instructor
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">

          {/* Left Content Section */}
          <div className="lg:col-span-2 space-y-8">

            {/* Content Sections */}
            <div className="space-y-8">
              {data.sections.map((section, index) => (
                <div key={index} className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/50 hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${index === 0 ? 'bg-gradient-to-r from-blue-500 to-cyan-500' :
                      index === 1 ? 'bg-gradient-to-r from-purple-500 to-indigo-500' :
                        'bg-gradient-to-r from-green-500 to-emerald-500'
                      } shadow-lg`}>
                      {index === 0 ? <Target className="w-6 h-6 text-white" /> :
                        index === 1 ? <Users className="w-6 h-6 text-white" /> :
                          <Award className="w-6 h-6 text-white" />}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-gray-800 mb-3">
                        {section.heading}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        {section.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Requirements Section */}
            <div className="bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-3xl p-8 shadow-xl">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl flex items-center justify-center shadow-lg mr-4">
                  <CheckCircle className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">
                  What does it take?
                </h3>
              </div>
              <div className="grid gap-4">
                {data.requirements.map((item, index) => (
                  <div key={index} className="flex items-start space-x-4 bg-white/60 backdrop-blur-sm rounded-xl p-4 hover:bg-white/80 transition-all duration-300">
                    <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <CheckCircle className="w-4 h-4 text-white" />
                    </div>
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Form Section - Sticky */}
          <div className="lg:sticky lg:top-8">
            <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/50 p-8 relative overflow-hidden">
              {/* Decorative Background */}
              <div className="!absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-100/50 to-purple-100/50 rounded-full -translate-y-16 translate-x-16"></div>

              <div className="relative z-10">
                <div className="text-center mb-8">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <Send className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    INTERESTED IN WORKING WITH US?
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Please submit this form and a yslearn representative will reach out to you.
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-6">

                  {/* Name Field */}
                  <div className="relative group">
                    <User className="!absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Your Name"
                      className="w-full !pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:bg-blue-50 transition-all duration-300"
                      required
                    />
                  </div>

                  {/* Email Field */}
                  <div className="relative group">
                    <Mail className="!absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Your Email"
                      className="w-full !pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:bg-blue-50 transition-all duration-300"
                      required
                    />
                  </div>

                  {/* Course Selection */}
                  <div className="relative group">
                    <BookOpen className="!absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                    <select
                      name="course"
                      value={formData.course}
                      onChange={handleInputChange}
                      className="w-full !pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:bg-blue-50 transition-all duration-300 appearance-none bg-white"
                      required
                    >
                      <option value="">Select Course</option>
                      {courses?.all?.courses?.map((course) => (
                        <option key={course?.CourseName} value={course?.CourseName}>
                          {course.CourseName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Phone Field */}
                  <div className="relative group">
                    <Phone className="!absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Phone Number"
                      className="w-full !pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:bg-blue-50 transition-all duration-300"
                      required
                    />
                  </div>

                  {/* LinkedIn Field */}
                  <div className="relative group">
                    <ExternalLink className="!absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                    <input
                      type="url"
                      name="linkedin"
                      value={formData.linkedin}
                      onChange={handleInputChange}
                      placeholder="LinkedIn URL"
                      className="w-full !pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:bg-blue-50 transition-all duration-300"
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-4 px-6 rounded-xl font-bold text-white transition-all duration-300 transform ${isSubmitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 hover:scale-105 shadow-lg hover:shadow-xl"
                      }`}
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <Loader2 className="w-5 h-5 animate-spin mr-2" />
                        Submitting...
                      </div>
                    ) : (
                      <div className="flex items-center justify-center">
                        <Send className="w-5 h-5 mr-2" />
                        SUBMIT APPLICATION
                      </div>
                    )}
                  </button>
                </form>

                {/* Trust Indicators */}
                <div className="mt-6 pt-6 border-t border-gray-200">
                  <div className="flex items-center justify-center space-x-4 text-sm text-gray-600">
                    <div className="flex items-center">
                      <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
                      <span>Secure</span>
                    </div>
                    <div className="flex items-center">
                      <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
                      <span>24hr Response</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestedForm;